import React from 'react';
import { AdminSidebar } from './AdminSidebar';
import AdminNavbar from './AdminNavbar';

export const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark flex">
      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 w-64 bg-white dark:bg-zinc-900 border-r border-gray-200 dark:border-zinc-800 z-30 flex flex-col">
        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto p-4 space-y-1">
          <AdminSidebar />
        </nav>
      </aside>
      {/* Main Content */}
      <div className="flex-1 ml-64 flex flex-col min-h-screen">
        <header className="sticky top-0 z-20 bg-white dark:bg-zinc-900 h-16 shadow flex items-center px-6">
          <AdminNavbar />
        </header>
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
}; 